/* eslint-disable no-restricted-globals */
import React from "react";
import { Divider, Table, Spin } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";






function Appeals() {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
    },
    {
      title: "Type",
      dataIndex: "atype_display",
      key: "atype_display",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Operation",
      dataIndex: "name",
      key: "name",
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      render: (text, record) => <a onClick={() => navigate('/e/' + record.event)}>{text}</a>
    },
    {
      title: "Disaster Type",
      dataIndex: 'dtypename',
    },
    {
      title: "Requested Amount",
      dataIndex: "amount_requested",
      key: "amount_requested",
    },
    {
      title: "Funding",
      dataIndex: "amount_funded",
      key: "amount_funded",
    },
    {
      title: "Country",
      dataIndex: "cname",
    },
  ];
  const url = 'https://goadmin.ifrc.org/api/v2/appeal/?limit=50&ordering=-start_date&country=194&offset=0'
    
  const [post, setPost] = React.useState(null);

    React.useEffect(() => {
      axios.get(url).then((response) => {
        for (var i = 0; i < response.data.results.length; i++) {
          // eslint-disable-next-line no-unused-expressions
          response.data.results[i].start_date =
            response.data.results[i].start_date.substring(0,10);
          response.data.results[i].dtypename =
            response.data.results[i].dtype.name;
            response.data.results[i].cname =
            response.data.results[i].country.name;
        }
        setPost(response.data);
        console.log(response.data);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    if (!post) return null;

  return (
    <>
      <section>
        <div class="container pt-20 pb-20">
          <div class="section-content">
            <div class="row">
              <div class="col-md-12">
                <div class="tabbable-panel">
                <Divider  orientation="left"><h3>ALL MONGOLIA OPERATIONS ({post.count})</h3></Divider>
                <Table dataSource={post.results} columns={columns} loading={{ indicator: <div><Spin /></div>, spinning:!post}}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Appeals;
